import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { ConfiguracoesDetail } from '../types'
import { configuracoesRepository } from './configuracoesRepository'

export const useConfiguracao = makeUseFetchOne<ConfiguracoesDetail, string>({
  fetch: configuracoesRepository.fetchOne
})
